import { mergeLeft } from 'ramda'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Option, Select } from '../../atoms'
import { getYears } from './helpers'
import { Container } from './styles'

interface MonthSelectValue {
  [key: string]: number | undefined
}

interface MonthSelectProps {
  value?: MonthSelectValue
  onChange: (value: MonthSelectValue) => void
  yearKey?: string
  monthKey?: string
  minDate?: Date
  maxDate?: Date
  setCurrentField?: (fieldId: string) => void
  shouldDisable?: boolean
  error?: boolean
}

export const MonthSelect: React.FC<MonthSelectProps> = ({
  value = {},
  onChange,
  yearKey = 'year',
  monthKey = 'month',
  minDate = new Date('1900'),
  maxDate = new Date(),
  setCurrentField,
  shouldDisable = true,
  error,
}) => {
  const { t } = useTranslation()
  const months = t('months', { returnObjects: true }) as string[]

  const years = useMemo(() => getYears(minDate, maxDate), [minDate, maxDate])

  const handleChange = (newValue: Record<string, number>) =>
    onChange(mergeLeft(newValue, value))

  return (
    <Container>
      <Select
        error={error}
        id="month-select"
        // @ts-expect-error seems to be an error but leaving this not to break the existing code
        onClick={() => setCurrentField?.('#month-select')}
        onSelect={(month?: string | number) => {
          if (!!month) handleChange({ [monthKey]: Number(month) })
        }}
        placeholder={t('common.month')}
        value={value?.[monthKey]}
      >
        {months.map((item, i) => {
          const disabled =
            new Date(`${value?.[yearKey]}-${String(i + 1).padStart(2, '0')}`) >
              maxDate ||
            new Date(`${value?.[yearKey]}-${String(i + 2).padStart(2, '0')}`) <
              minDate

          return (
            <Option
              key={item}
              disabled={shouldDisable && disabled}
              value={i + 1}
            >
              {item}
            </Option>
          )
        })}
      </Select>
      <Select
        disabled={years.length === 1}
        error={error}
        id="year-select"
        // @ts-expect-error seems to be an error but leaving this not to break the existing code
        onClick={() => setCurrentField?.('#year-select')}
        onSelect={(year?: string | number) => {
          if (!!year) handleChange({ [yearKey]: Number(year) })
        }}
        placeholder={t('common.year')}
        value={value?.[yearKey]}
      >
        {years.map((item) => (
          <Option key={item} value={item}>
            {item}
          </Option>
        ))}
      </Select>
    </Container>
  )
}
